import { render, staticRenderFns } from "./PreAceleracao.vue?vue&type=template&id=1a7bbd6c&scoped=true"
import script from "./PreAceleracao.vue?vue&type=script&lang=js"
export * from "./PreAceleracao.vue?vue&type=script&lang=js"
import style0 from "./PreAceleracao.vue?vue&type=style&index=0&id=1a7bbd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bbd6c",
  null
  
)

export default component.exports